import * as Long from "long";
import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var OfferGoldRewardTooltip = function (_a) {
    var offer = _a.offer;
    if (!offer) {
        return React.createElement(React.Fragment, null);
    }
    var baseGoldValue = offer.baseGoldValue, webBonusGold = offer.webBonusGold, rewards = offer.rewards, subscriptionBonus = offer.subscriptionBonus, primeTimeBonus = offer.primeTimeBonus, bonusGoldPercent = offer.bonusGoldPercent;
    var bonusGold = rewards.find(function (val) { return val.id === IdResource.Gold; });
    var subscriptionBuffPercentage = Long.ZERO;
    if (subscriptionBonus && subscriptionBonus.gt(Long.ZERO)) {
        subscriptionBuffPercentage = subscriptionBonus.multiply(100).divide(baseGoldValue);
    }
    var subscriptionReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(subscriptionBuffPercentage)],
    ]);
    var primeTimeComponent;
    if (primeTimeBonus && primeTimeBonus > 0) {
        var primeTimeReplacements = new Map([
            [ReplacementLoca.zero_0, utilNumber.format((bonusGoldPercent - 1) * 100)],
        ]);
        primeTimeComponent = (React.createElement("div", { className: "flex flex--aligned flex--spaced w100" },
            React.createElement(TextLoca, { id: IdLoca.tooltip_goldSum_PrimeTimeBonus, className: IdStyles.TextNormal, replacements: primeTimeReplacements }),
            React.createElement(NumberFormat, { amount: primeTimeBonus, className: IdStyles.TextBoldPrimary, format: TypeNumberFormat.AddExceptZero })));
    }
    var webBonusComponent;
    if (webBonusGold && webBonusGold > 0) {
        webBonusComponent = (React.createElement("div", { className: "flex flex--aligned flex--spaced w100 pt__medium" },
            React.createElement(TextLoca, { id: IdLoca.tooltip_goldSum_webBonus, className: IdStyles.TextNormal }),
            React.createElement(NumberFormat, { amount: webBonusGold || Long.ZERO, className: IdStyles.TextBoldPrimary, format: TypeNumberFormat.AddExceptZero })));
    }
    return (React.createElement("div", { className: "padding--medium" },
        React.createElement("div", { className: "padding--small offer-body__rewards-tooltip-title" },
            React.createElement(TextLoca, { id: IdLoca.tooltip_goldSum, className: IdStyles.TextBoldPrimary })),
        React.createElement("div", { className: "flex flex--aligned flex--spaced w100" },
            React.createElement(TextLoca, { id: IdLoca.tooltip_goldSum_OfferValue, className: IdStyles.TextNormal }),
            React.createElement(NumberFormat, { amount: baseGoldValue, className: IdStyles.TextBoldPrimary })),
        primeTimeComponent,
        subscriptionBonus && subscriptionBonus.gt(Long.ZERO) && (React.createElement("div", { className: "flex flex--aligned flex--spaced w100" },
            React.createElement(TextLoca, { id: IdLoca.tooltip_goldSum_subscriptionBonus, className: IdStyles.TextNormal, replacements: subscriptionReplacements }),
            React.createElement(NumberFormat, { amount: subscriptionBonus, className: IdStyles.TextBoldPrimary, format: TypeNumberFormat.AddExceptZero }))),
        bonusGold && (React.createElement("div", { className: "flex flex--aligned flex--spaced w100" },
            React.createElement(TextLoca, { id: IdLoca.tooltip_goldSum_extraGold, className: IdStyles.TextNormal }),
            React.createElement(NumberFormat, { amount: bonusGold.amount, className: IdStyles.TextBoldPrimary, format: TypeNumberFormat.AddExceptZero }))),
        webBonusComponent));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferGoldRewardTooltip.tsx
// module id = 446
// module chunks = 3